module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-26-ec9e3a33d53bdc983bbd5ef41c216c16.jpg";